export const Events = {
  viewFile: function (name) {
    if(window['gtag'] !== undefined) window['gtag']('event', 'view_item', { 'type': 'arquivo', 'name': name });
  },
  selectVideo: function (name) {
    if(window['gtag'] !== undefined) window['gtag']('event', 'view_item', { 'type': 'video', 'name': name });
  }, 
}

export const PageView = {
  view: function (page) {
    if (window['gtag_pageview'] !== undefined) window['gtag_pageview'](page)
  }
}